// removed by extract-text-webpack-plugin
module.exports = {"base":"ShopView_base--IkWS-","strongholdBackground":"ShopView_strongholdBackground--3dldM"};


//////////////////
// WEBPACK FOOTER
// ./containers/ShopView/ShopView.scss
// module id = 2487
// module chunks = 11